import { queryOptions } from '@tanstack/react-query'

import { w } from '@/lib/api'
import { API_ENDPOINTS } from '@/lib/constants/api'

import type { ResGetCaseVisaBulletinTrendQuery } from './types'

export const getCaseVisaBulletinTrendQueryKey = (filter: { country?: string; visaType?: string }) => [
  API_ENDPOINTS.case.public.trend['visa-bulletin'].index,
  filter.country,
  filter.visaType,
]

export const getCaseVisaBulletinTrendQuery = (filter: { country?: string; visaType?: string; date: string }) => {
  const enabled = !!filter.country && !!filter.visaType

  return queryOptions({
    enabled,
    queryKey: getCaseVisaBulletinTrendQueryKey(filter),
    queryFn: () =>
      w
        .url(API_ENDPOINTS.case.public.trend['visa-bulletin'].index)
        .query(filter)
        .get()
        .json<ResGetCaseVisaBulletinTrendQuery>(),
    retry: false,
    refetchOnWindowFocus: false,
  })
}
